import { render, staticRenderFns } from "./DotRemindContent.vue?vue&type=template&id=4012de06"
import script from "./DotRemindContent.vue?vue&type=script&lang=js"
export * from "./DotRemindContent.vue?vue&type=script&lang=js"
import style0 from "./DotRemindContent.vue?vue&type=style&index=0&id=4012de06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports